export default __webpack_public_path__ + "static/media/GalleryFirstFullSize.e0cd3b02.jpg";